<template>
  <g class="directors-list">
    <text>
      <tspan
        :x="nodes[0].x + 150"
        :y="10 * Object.keys(directors).length">
        <template v-if="this.hasOwnProperty('$i18n')">
          {{ $t('directors') }}
        </template>
        <template v-else>
          Directors
        </template>
        :</tspan>
      <tspan
        :x="nodes[0].x + 160"
        dy="1.2em"
        v-for="(director, index) in directors"
        :key="index">{{index + 1}}. {{director}}</tspan>
    </text>
  </g>
</template>

<script>

export default {
  name: 'DiagramDirectorsList',
  props: [
    'directors',
    'nodes'
  ],
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>
